import React, { FunctionComponent, ReactNode } from 'react'
import classnames from 'classnames'
import { StatusPill } from '../common/statusPill'

export interface Props {
  title: string | ReactNode
  titleRight?: string | ReactNode
  status?: string
  gridClass?: string
  noBorder?: boolean
}

export const RefiTransactionsCard: FunctionComponent<Props> = ({
  title,
  titleRight,
  status,
  children,
  noBorder,
  gridClass,
}) => {
  return (
    <div
      className={classnames('refiTransactionCard', gridClass || null, {
        'refiTransactionCard--no-border': noBorder,
      })}
    >
      <div className="refiTransactionCard__title">
        {title}
        <div className="refiTransactionCard__status">
          {status && <StatusPill withIcon status={status} />}
          {titleRight && (
            <div className="refiTransactionCard__rating">{titleRight}</div>
          )}
        </div>
      </div>
      {children}
    </div>
  )
}

RefiTransactionsCard.displayName = 'RefiTransactionsCard'
